import { QuestionnaireResponseItem } from '@medplum/fhirtypes'
import { AdapterOptions } from '../../../../../adapters/types'
import { DischargeFormData } from '../../../../types/formData'
import { DischargeFormField } from '../../../../types/formField'
import { DischargeAssessmentQuestionnaireItem } from '../../../../types/questionnaire'
import { getAnswerValuesFromItems } from '../../../../../helpers'
import { BaseSubsectionAdapter } from '../../../../../adapters/BaseSubsectionAdapter'
import { FlatAnswerMutation } from '../../../../../adapters/types'

/**
 * Therapies subsection adapter
 * Handles therapy services and home exercise plans (5 fields)
 */
export class TherapiesAdapter extends BaseSubsectionAdapter<DischargeFormData> {
  extractFormData(
    flatAnswers: Record<string, QuestionnaireResponseItem>,
    _options?: AdapterOptions
  ): Partial<DischargeFormData> {
    const flatAnswersArray = Object.values(flatAnswers)

    // Direct field extractions
    const therapies = getAnswerValuesFromItems(
      flatAnswersArray,
      DischargeAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_THERAPIES_THERAPIES
    )

    const therapyProvider = getAnswerValuesFromItems(
      flatAnswersArray,
      DischargeAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_THERAPIES_THERAPY_PROVIDER
    )?.at(0)

    const homeExercisePlan = getAnswerValuesFromItems(
      flatAnswersArray,
      DischargeAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_THERAPIES_HOME_EXERCISE_PLAN
    )?.at(0)

    const homeExerciseDuration = getAnswerValuesFromItems(
      flatAnswersArray,
      DischargeAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_THERAPIES_HOME_EXERCISE_DURATION
    )?.at(0)

    const homeExerciseFrequency = getAnswerValuesFromItems(
      flatAnswersArray,
      DischargeAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_THERAPIES_HOME_EXERCISE_FREQUENCY
    )?.at(0)

    return {
      [DischargeFormField.THERAPIES_THERAPIES]: therapies,
      [DischargeFormField.THERAPIES_THERAPY_PROVIDER]: therapyProvider,
      [DischargeFormField.THERAPIES_HOME_EXERCISE_PLAN]: homeExercisePlan,
      [DischargeFormField.THERAPIES_HOME_EXERCISE_DURATION]: homeExerciseDuration,
      [DischargeFormField.THERAPIES_HOME_EXERCISE_FREQUENCY]: homeExerciseFrequency
    }
  }

  buildFlatAnswers(): FlatAnswerMutation[] {
    const mutations: FlatAnswerMutation[] = []

    if (this.formDataFieldExists(DischargeFormField.THERAPIES_THERAPIES)) {
      mutations.push({
        linkId: DischargeAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_THERAPIES_THERAPIES,
        value: this.getFormDataField(DischargeFormField.THERAPIES_THERAPIES)
      })
    }
    if (this.formDataFieldExists(DischargeFormField.THERAPIES_THERAPY_PROVIDER)) {
      mutations.push({
        linkId: DischargeAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_THERAPIES_THERAPY_PROVIDER,
        value: this.getFormDataField(DischargeFormField.THERAPIES_THERAPY_PROVIDER)
      })
    }
    if (this.formDataFieldExists(DischargeFormField.THERAPIES_HOME_EXERCISE_PLAN)) {
      mutations.push({
        linkId:
          DischargeAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_THERAPIES_HOME_EXERCISE_PLAN,
        value: this.getFormDataField(DischargeFormField.THERAPIES_HOME_EXERCISE_PLAN)
      })
    }
    if (this.formDataFieldExists(DischargeFormField.THERAPIES_HOME_EXERCISE_DURATION)) {
      mutations.push({
        linkId:
          DischargeAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_THERAPIES_HOME_EXERCISE_DURATION,
        value: this.getFormDataField(DischargeFormField.THERAPIES_HOME_EXERCISE_DURATION)
      })
    }
    if (this.formDataFieldExists(DischargeFormField.THERAPIES_HOME_EXERCISE_FREQUENCY)) {
      mutations.push({
        linkId:
          DischargeAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_THERAPIES_HOME_EXERCISE_FREQUENCY,
        value: this.getFormDataField(DischargeFormField.THERAPIES_HOME_EXERCISE_FREQUENCY)
      })
    }

    return mutations
  }
}
